export default "__VITE_ASSET__BahC_5fw__"